/** Matches Supabase Auth's default minimum interval between emails to the same address. */
export const MAGIC_LINK_RESEND_COOLDOWN_MS = 60_000;

export function cooldownSecondsLeft(endsAt: number | null, now: number): number {
  if (endsAt === null) return 0;
  return Math.max(0, Math.ceil((endsAt - now) / 1000));
}
